module.exports = __webpack_public_path__ + "static/img/backhome.2a98afe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/backhome.png
// module id = 1Ef8
// module chunks = 1